/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Acknowledgement of a state report.
 */
export type ReportStateResult = {
  /**
   * The applied etag the server now holds for this device.
   */
  appliedEtag?: string | undefined;
  /**
   * When the server received the report.
   */
  receivedAt: Date;
  /**
   * False when the report was accepted but not stored because it came from a non-endpoint environment.
   */
  stored: boolean;
};

/** @internal */
export const ReportStateResult$inboundSchema: z.ZodMiniType<
  ReportStateResult,
  unknown
> = z.pipe(
  z.object({
    applied_etag: z.optional(z.string()),
    received_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    stored: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "applied_etag": "appliedEtag",
      "received_at": "receivedAt",
    });
  }),
);

export function reportStateResultFromJSON(
  jsonString: string,
): SafeParseResult<ReportStateResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ReportStateResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ReportStateResult' from JSON`,
  );
}
